import { useMutation } from "@apollo/client/react";
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { VALIDATE_RI } from "../../../data/graphQL/mutations/ResumenIngresoValidation/ValidateRI";
import { MODIFICATE_RI } from "../../../data/graphQL/mutations/ResumenIngresoValidation/ModificacionRI";
import { REASIGNAR_PROFESIONAL_RI } from "../../../data/graphQL/mutations/ResumenIngresoValidation/ReasignarProfesionalRI";
import { VALIDATE_CONTRATO } from "../../../data/graphQL/mutations/Contratos/validateContrato";
import { REGISTRAR_DEMORA } from "../../../data/graphQL/mutations/ResumenIngresoValidation/RegistrarDemora";
import { CAMBIAR_PROGRAMA_EVALUACION } from '../../../data/graphQL/mutations/ResumenIngresoValidation/CambiarProgramaEvaluacion';

export const useGetActions = ({ handleChange, notification, location }) => {
  const navigate = useNavigate();

  const [validarRI, { loading: validateLoading }] = useMutation(VALIDATE_RI, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      toast.success("Se ejecutó la validación correctamente!");
    }
  });

  const [modificarRI, { loading: modificarLoading }] = useMutation(MODIFICATE_RI, {
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        idEvaluacion: notification?.idEvaluacion,
        idMotivoRechazo: notification?.idMotivoRechazo,
        observacion: null,
        tipoNotificacion: "RESUMEN_INGRESO"
      }
    }
  });

  const [reAsignarProfesional, { loading: asignarLoading }] = useMutation(REASIGNAR_PROFESIONAL_RI, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      toast.success('Se reasignó al profesional correctamente!');
    }
  });

  const [validateContrato] = useMutation(VALIDATE_CONTRATO, { variables: { idEvaluacion: notification?.idEvaluacion } });

  const [registrarDemora, { loading: demoraLoading }] = useMutation(REGISTRAR_DEMORA, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      toast.success('Se registró la demora correctamente!');
    }
  });

  const [cambiarPrograma, { loading: cambiarProgramaLoading }] = useMutation(CAMBIAR_PROGRAMA_EVALUACION, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      toast.success('Se cambió el programa correctamente!');
    }
  });

  const handleClickAsignar = (row) => {
    const nombreCompleto = row.nombre + ' ' + row.apellido;
    handleChange('profesionalASignado', nombreCompleto);

    reAsignarProfesional({
      variables: {
        input: {
          idProfesional: row?.codigoProfesional,
          idDatosGeneralesRI: notification?.idDatosGenerales,
          fechaLimite: notification?.fechaLimite,
          idEvaluacion: notification?.idEvaluacion
        }
      }
    }).then(() => {
      setTimeout(() => navigate('/asignacionValidacionResumenIngreso'), 1000);
    }).catch(() => toast.error('Ha ocurrido un error!'));;
  };

  const handleClickValidar = (rechazo) => {
    if (notification.estadoRI === 'Aprobado') {
      validarRI({
        variables: {
          input: {
            idEvaluacion: notification?.idEvaluacion,
            idMotivoRechazo: rechazo?.idMotivoRechazo,
            observacion: rechazo?.observacion,
            tipoNotificacion: "RESUMEN_INGRESO",
            requiereIndicacion: false
          }
        }
      }).then(() => {
        setTimeout(() => navigate('/asignacionValidacionResumenIngreso'), 1000);

        if (rechazo?.idMotivoRechazo)
        validateContrato();
      }).catch((error) => {
        const gqlErrorMessage = error?.graphQLErrors?.[0]?.extensions?.message;
        toast.error(gqlErrorMessage || 'Ha ocurrido un error!');
      });
    } else

    toast.error('No se puede validar un resumen de ingreso que no este aprobado.');
  };

  const handleClickModificarRI = () => {
    modificarRI().then((res) => {

      navigate(location.pathname, {
        state: {
          ...location.state,
          notificationData: {
            ...location.state.notificationData,
            idDatosGenerales: res?.data?.modificacionRI
          }
        },
        replace: true
      });

      navigate('/resumenIngreso/crearResumenIngreso', {
        state: {
          idDatosGeneralesRI: res?.data?.modificacionRI,
          edit: true
        }
      });
    }).catch(() => toast.error('Ha ocurrido un error!'));
  };

  const handleClickRegistrarDemora = (demora) => {
    registrarDemora({
      variables: {
        input: {
          idEvaluacion: notification?.idEvaluacion,
          fechaFinDemora: demora?.fechaFinDemora,
          idMotivoDemora: demora?.idMotivoDemora,
          observacion: demora?.observacion
        }
      }
    }).then(() => {
      setTimeout(() => navigate('/asignacionValidacionResumenIngreso'), 1000);
    }).catch(() => toast.error('Ha ocurrido un error!'));
  };

  const handleClickCambiarPrograma = () => {
    cambiarPrograma({
      variables: {
        idEvaluacion: notification?.idEvaluacion,
        tipoNotificacionAsistencial: "RESUMEN_INGRESO"
      }
    }).then((res) => {
      if (!res?.data?.cambiarProgramaContrato?.success)
      toast.error(res?.data?.cambiarProgramaContrato?.error || 'Ha ocurrido un error!');
      setTimeout(() => navigate('/asignacionValidacionResumenIngreso'), 1000);
    }).catch(() => toast.error('Ha ocurrido un error!'));
  };

  return {
    handleClickAsignar,
    handleClickValidar,
    handleClickModificarRI,
    handleClickRegistrarDemora,
    handleClickCambiarPrograma,
    loading: validateLoading || modificarLoading || asignarLoading || demoraLoading || cambiarProgramaLoading
  };
};